var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicleRightSide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 160,
    viewBox: "0 0 346 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.162 3.93053C215.93 2.37855 214.596 2.33543 201.768 2.2061L18.5196 1.17145C11.5461 1.17145 10.47 6.34472 9.95341 10.5265C7.58586 30.2711 3.71169 63.8112 3.28122 83.4697C3.02295 95.1957 2.89374 107.094 2.89374 118.993V126.753C2.89374 128.563 1.12891 127.83 1.12891 131.581C1.12891 135.504 4.27125 142.445 16.3673 142.833C22.6951 143.049 39.5262 142.574 43.0129 141.453C44.2182 141.065 44.8209 141.022 44.8639 139.988C45.6818 129.857 50.2878 118.131 57.5196 114.294C62.9004 111.448 76.6322 111.492 82.4865 114.294C90.5792 118.131 95.0559 128.563 95.3142 138.91C95.7016 140.764 96.6056 142.057 97.5957 142.057L259.063 142.79C260.354 142.79 262.248 142.531 262.42 140.979C263.884 125.503 270.427 115.372 278.132 112.354C283.728 110.155 292.294 111.017 297.546 112.871C309.341 117.01 311.837 132.271 313.904 141.669C322.125 143.049 326.215 143.178 333.36 141.109C337.622 139.858 345.37 136.323 344.983 131.754L344.208 123.476C344.036 121.407 343.089 119.683 341.884 119.424C342.745 109.164 343.132 106.922 337.579 99.8517C331.423 92.0056 320.92 86.0132 312.784 80.1501C310.89 78.7706 307.188 75.4511 306.327 73.2955H302.152C291.046 60.4055 274.559 43.4199 261.387 30.8747C253.596 23.4165 242.447 13.8891 233.192 8.37092C230.308 6.73272 226.562 4.66341 223.162 3.93053Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80793 115.545C2.80793 116.709 2.80793 117.83 2.80793 118.994V126.754C2.80793 128.607 1 127.875 1 131.582C1 135.505 4.14234 142.446 16.2384 142.877C16.4105 142.877 16.6258 142.877 16.8411 142.877V115.545H2.80793Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.013 22.4691L210.55 143.093",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7877 20.8308L16.9697 137.402L44.9929 137.488",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.417 83.9449C232.417 83.9018 232.417 83.9018 232.374 83.8587C232.202 82.6947 231.298 82.0481 229.834 81.8325C228.37 81.6601 228.241 81.6601 226.907 81.8325C225.615 82.005 224.755 82.781 224.41 83.8587C224.755 82.8241 225.615 82.005 226.907 81.8325C228.241 81.6601 228.413 81.6601 229.834 81.8325C231.298 82.0481 232.202 82.6947 232.374 83.8587C232.417 83.9018 232.417 83.9449 232.417 83.9449Z",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.109 83.8592C198.109 83.8161 198.109 83.8161 198.152 83.773C198.325 82.609 199.229 81.9623 200.692 81.7468C202.156 81.5743 202.285 81.5743 203.619 81.7468C204.911 81.9192 205.772 82.6952 206.116 83.773C205.772 82.7383 204.911 81.9192 203.619 81.7468C202.285 81.5743 202.113 81.5743 200.692 81.7468C199.229 81.9623 198.325 82.609 198.152 83.773C198.109 83.8161 198.109 83.8161 198.109 83.8592Z",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M224.41 86.4887C224.625 87.5234 225.572 88.7305 226.907 88.9029C228.284 89.0754 228.456 89.0754 229.834 88.9029C231.254 88.7305 232.288 87.9114 232.374 86.8767C232.417 86.7043 232.417 86.5749 232.417 86.4456C232.374 86.5749 232.374 86.7043 232.374 86.8767C232.288 87.9114 231.254 88.6874 229.834 88.9029C228.456 89.0754 228.284 89.0754 226.907 88.9029C225.572 88.6874 224.625 87.4803 224.41 86.4887Z",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206.116 86.359C205.901 87.3936 204.954 88.6007 203.619 88.7732C202.242 88.9456 202.07 88.9456 200.692 88.7732C199.272 88.6007 198.239 87.7816 198.152 86.747C198.109 86.5745 198.109 86.4452 198.109 86.3159C198.152 86.4452 198.152 86.5745 198.152 86.747C198.239 87.7816 199.272 88.5576 200.692 88.7732C202.07 88.9456 202.242 88.9456 203.619 88.7732C204.997 88.6007 205.901 87.3936 206.116 86.359Z",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M225.659 86.4453C225.702 86.4022 225.702 86.2729 225.702 86.2298V84.1604C225.702 84.0742 225.659 83.988 225.659 83.9449H236.378C236.894 83.9449 237.282 84.3329 237.282 84.8933V85.4969C237.282 86.0142 236.894 86.4453 236.378 86.4453H225.659Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204.867 86.3591C204.824 86.316 204.824 86.1866 204.824 86.1435V84.0742C204.824 83.988 204.867 83.9018 204.867 83.8586H194.148C193.632 83.8586 193.244 84.2466 193.244 84.8071V85.4106C193.244 85.928 193.632 86.3591 194.148 86.3591H204.867Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M307.963 129.599C304.821 121.192 296.556 115.501 287.56 115.501C275.636 115.501 265.864 125.244 265.864 137.272C265.864 149.214 275.636 159 287.56 159C299.569 159 309.298 149.214 309.298 137.272C309.298 134.686 308.824 132.013 307.963 129.599Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5261 129.599C88.3837 121.192 80.1188 115.501 71.1221 115.501C59.1982 115.501 49.4268 125.244 49.4268 137.272C49.4268 149.214 59.1982 159 71.1221 159C83.132 159 92.8605 149.214 92.8605 137.272C92.8605 134.686 92.387 132.013 91.5261 129.599Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M274.517 142.187C276.583 147.619 281.835 151.24 287.56 151.24C295.179 151.24 301.464 144.946 301.464 137.316C301.464 129.685 295.179 123.391 287.56 123.391C279.941 123.391 273.656 129.685 273.656 137.316C273.656 138.954 273.958 140.678 274.517 142.187Z",
    fill: "#EBE9E9",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0797 142.187C60.1459 147.619 65.3976 151.24 71.1227 151.24C78.7419 151.24 85.0267 144.946 85.0267 137.316C85.0267 129.685 78.7419 123.391 71.1227 123.391C63.5035 123.391 57.2188 129.685 57.2188 137.316C57.2188 138.954 57.5201 140.678 58.0797 142.187Z",
    fill: "#EBE9E9",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M327.635 114.768C331.036 116.191 334.609 115.932 337.751 116.364C338.483 116.45 339.387 115.846 339.473 114.596C339.688 111.32 337.579 105.413 335.082 104.379C333.274 103.646 331.036 103.085 328.281 102.741C327.076 102.568 322.082 102.137 318.682 102.353C319.586 106.233 323.589 113.087 327.635 114.768Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M292.209 73.5116C293.586 75.7102 295.481 77.0036 297.59 78.2107C303.401 81.444 319.543 92.4372 323.977 96.6189C328.971 101.318 328.411 100.973 328.583 102.87",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M220.321 37.256L221.57 69.1148C221.742 74.8054 226.477 77.7369 229.705 78.4267C261.344 85.1088 292.725 90.4546 323.417 98.9474C330.003 100.758 331.897 102.267 335.772 103.862",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M284.245 77.3917C265.649 76.7019 246.665 74.4171 229.404 72.0029C224.367 71.27 223.334 67.778 222.99 64.4154L220.278 36.9539C220.106 35.4882 222.086 34.1086 223.507 34.1086C231.298 34.0224 242.06 33.7206 248.689 35.0571C251.659 35.6606 253.122 36.5659 254.629 38.1179C264.702 48.5507 277.314 61.7857 285.838 72.6495C289.066 76.745 291.993 77.6504 284.245 77.3917Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M252.133 36.9539L255.533 74.5895C254.027 74.4171 252.477 74.2878 250.927 74.0722C243.825 73.2962 236.507 72.2616 229.404 71.3131C225.272 70.7096 223.894 68.166 223.507 64.2861L220.795 36.8677C221.01 34.0655 225.401 34.6691 227.252 34.5829C233.451 34.5829 239.692 34.4104 245.891 35.1864C248.259 35.4882 250.325 35.9193 252.133 36.9539Z",
    fill: "#F6F6F6",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M256.781 74.7193L253.337 37.7734C253.638 38.0321 253.94 38.2908 254.155 38.5063C260.827 45.404 267.499 52.4742 273.913 59.6305C274.516 60.3634 275.979 62.4327 276.065 63.2087C276.582 68.4682 276.453 72.6931 276.065 76.3575C269.651 75.9695 263.195 75.409 256.781 74.7193Z",
    fill: "#F6F6F6",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M219.246 138.264L216.835 103.647V34.0661C216.835 31.695 218.342 30.919 220.537 30.919C229.792 30.8759 237.54 31.307 246.408 32.4279C250.11 32.9021 253.984 33.8936 257.6 37.8167L280.845 63.4244C282.136 64.804 281.964 64.2435 281.964 65.5799L281.663 77.4354L282.179 111.536",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M219.246 138.264L216.835 103.647V34.0661C216.835 31.695 218.342 30.919 220.537 30.919C229.792 30.8759 237.54 31.307 246.408 32.4279C250.11 32.9021 253.984 33.8936 257.6 37.8167L280.845 63.4244C282.136 64.804 281.964 64.2435 281.964 65.5799L281.663 77.4354L282.179 111.536",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M282.135 106.061C295.565 105.112 308.608 109.553 310.976 118.735",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M225.142 83.5996H221.784C221.44 83.5996 221.182 83.8583 221.182 84.2032V86.2725C221.182 86.6174 221.44 86.876 221.784 86.876H225.142C225.486 86.876 225.744 86.6174 225.744 86.2725V84.2032C225.701 83.8152 225.443 83.5996 225.142 83.5996Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M205.428 83.4698H208.785C209.13 83.4698 209.388 83.7284 209.388 84.0733V86.1426C209.388 86.4875 209.13 86.7462 208.785 86.7462H205.428C205.083 86.7462 204.825 86.4875 204.825 86.1426V84.0733C204.825 83.7284 205.083 83.4698 205.428 83.4698Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M223.42 84.3331C222.947 84.3331 222.56 84.7211 222.56 85.2384C222.56 85.7127 222.947 86.1007 223.42 86.1007C223.937 86.1007 224.325 85.7127 224.325 85.2384C224.325 84.7211 223.894 84.3331 223.42 84.3331Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M207.106 84.246C207.58 84.246 207.967 84.634 207.967 85.1513C207.967 85.6255 207.58 86.0135 207.106 86.0135C206.59 86.0135 206.202 85.6255 206.202 85.1513C206.202 84.634 206.633 84.246 207.106 84.246Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5727 140.765C38.364 141.282 21.9204 141.153 16.7979 140.765",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.059 127.486H2.97949",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1353 118.649L48.3506 118.821C50.0725 118.821 51.536 116.235 49.4697 116.235L20.4996 116.062C19.1652 116.062 18.4334 118.562 20.4996 118.649H21.4896",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5727 119.684L259.708 121.408C261.99 121.408 261.904 118.261 260.311 118.261L92.9899 116.537C90.3211 116.494 92.1721 119.684 93.5496 119.684H94.4535",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85059 117.614H16.7545",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M147.099 70.7534L202.284 71.7018C204.652 71.7018 206.89 69.6325 206.89 67.089V38.6791C206.89 36.1355 204.824 34.0662 202.284 34.0662L144.688 33.1178C142.148 33.0747 140.082 35.3595 140.082 37.7306V66.1405C140.082 68.4685 142.364 70.7534 144.688 70.7534H145.721",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.162 69.0712L77.7083 69.8903L128.89 70.7525C131.172 70.7525 133.496 68.6832 133.496 66.1397V37.7298C133.496 35.1863 131.43 33.1169 128.89 33.1169L75.2547 32.2547L25.7944 31.4356C23.2547 31.3925 21.1885 33.8067 21.1885 36.0485V64.4584C21.1885 66.7432 23.556 69.0712 25.7944 69.0712H26.8276",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M148.95 69.1147L200.434 69.8476C204.609 69.8907 205.039 67.7783 205.039 65.2348V40.5324C205.039 37.2129 202.973 35.9195 200.434 35.9195L146.582 35.1867C143.354 35.1436 141.977 36.8249 141.977 39.7995V64.4588C141.977 67.8645 143.354 69.0716 146.582 69.0716H147.616",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0127 67.3036L80.1187 68.252L126.996 68.8555C131.129 68.8987 131.602 66.7862 131.602 64.2427V39.5834C131.602 36.2639 129.536 34.9706 126.996 34.9706L78.3537 34.367L27.6021 33.4186C24.3737 33.3755 22.9961 35.1861 22.9961 38.0314V62.6476C22.9961 66.0102 24.4167 67.2604 27.6021 67.2604H28.6352",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87396 47.8608L12.7944 48.2057C13.6123 48.2057 13.7414 48.8093 13.7414 49.1542L13.6985 52.7323C13.6985 53.4652 12.9667 53.6808 12.7515 53.6808L4.35742 54.6292",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62591 108.949L12.1922 109.294C13.0101 109.294 13.1392 109.897 13.1392 110.242L13.0961 113.82C13.0961 114.51 12.3213 114.769 12.1491 114.769L3.10938 115.717",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M331.939 115.933V119.209",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M337.666 116.407V119.209",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M305.467 118.649C310.718 125.116 312.483 134.988 313.947 141.799C322.126 143.179 326.344 143.179 333.404 141.196C337.536 140.075 345.414 136.497 344.983 131.884L344.251 123.607C344.079 121.494 343.132 119.77 341.884 119.511C341.884 119.425 341.884 119.339 341.884 119.296L305.467 118.649Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M343.434 120.761L306.629 120.115",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M304.305 73.3827H302.195C291.046 60.4495 274.603 43.5933 261.388 30.9619C261.345 30.9188 261.345 30.9188 261.345 30.9188L254.414 31.3068C266.596 44.7573 280.328 59.8029 292.209 73.4258L304.305 73.3827Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M261.99 31.4796C274.904 43.8523 290.745 60.1481 301.722 72.7795H292.467C289.496 69.4169 286.483 65.925 283.427 62.5623C274.301 52.2158 264.96 42.0848 255.705 31.8244L261.99 31.4796Z",
    fill: "#F6F6F6",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4863 138.135L256.049 138.868C256.652 138.868 257.341 138.609 257.427 138.006C260.526 121.322 266.897 108.216 282.092 106.061",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M336.201 104.897C334.953 101.836 332.757 98.2576 329.098 94.9812C322.125 88.7302 313.989 83.1689 305.595 77.5645L302.711 73.4259",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M286.871 77.4341H296.643L309.47 77.3917",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M286.871 77.4341H296.643L309.47 77.3917",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M318.596 102.396C307.318 101.06 295.394 100.154 282.05 100.025L22.3084 97.2228C20.5435 97.1797 19.7256 98.7317 19.7256 99.9819C19.7256 101.232 19.5964 102.698 22.3084 102.698L282.05 105.5C294.706 105.586 307.619 106.104 320.232 106.75",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76465 108.777C2.80769 100.068 2.9369 92.524 3.15213 83.9019C6.76802 84.5054 11.1157 91.4462 11.1157 94.3777V106.233C11.1157 107.656 10.8574 108.82 8.40376 108.82H2.76465V108.777Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89357 93.1276C2.85052 94.5502 2.85059 95.9729 2.85059 97.3955H11.1155V94.3347C11.1155 93.9467 11.0293 93.5587 10.9432 93.1276H2.89357Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85071 97.4385C2.80766 99.2922 2.80762 101.146 2.80762 103.043H11.1156V97.4385H2.85071Z",
    fill: "#F6F6F6",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5264 129.599C88.384 121.149 80.1191 115.501 71.0794 115.501C59.1986 115.501 49.384 125.244 49.384 137.272C49.384 138.221 49.4271 139.126 49.5562 140.031H44.9502C44.9502 140.031 44.9502 139.988 44.9933 139.988C45.8112 129.857 50.374 118.131 57.6489 114.294C62.9866 111.449 76.7614 111.492 82.6157 114.294C90.7515 118.131 95.1853 128.564 95.4436 138.954C95.4866 139.342 95.6157 139.687 95.7449 140.031H92.6456C92.7747 139.126 92.8178 138.221 92.8178 137.272C92.8609 134.686 92.3873 132.013 91.5264 129.599Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M307.921 129.556C304.778 121.193 296.514 115.459 287.517 115.459C275.55 115.459 265.822 125.288 265.822 137.23C265.822 138.265 265.865 139.299 265.994 140.248H262.421C263.928 125.245 270.557 115.373 278.09 112.398C283.686 110.243 292.338 111.148 297.504 112.959C308.653 116.796 311.494 130.763 313.517 140.248H309.083C309.212 139.256 309.298 138.265 309.298 137.23C309.298 134.686 308.825 131.97 307.921 129.556Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M186.271 142.317H154.934L155.622 144.602L184.937 145.033L186.271 142.317Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M288.765 97.8694C290.025 97.8694 291.046 97.3482 291.046 96.7054C291.046 96.0625 290.025 95.5414 288.765 95.5414C287.505 95.5414 286.483 96.0625 286.483 96.7054C286.483 97.3482 287.505 97.8694 288.765 97.8694Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M281.963 59.5442L279.251 58.5095C278.433 58.1646 277.788 59.3717 277.659 60.1046C276.41 65.321 275.291 70.6236 275.635 75.8831C275.678 76.616 276.453 77.4782 277.228 77.4782H280.844C281.576 77.4782 282.265 76.7022 282.437 75.8831C283.47 71.2703 283.857 66.5712 283.556 61.8291C283.513 61.01 282.781 59.8891 281.963 59.5442Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M341.883 107.655C342.615 110.587 342.4 113.82 341.926 119.252H339.645C339.645 115.113 339.688 111.535 337.837 107.655H341.883Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M344.682 133.695C344.94 133.091 345.026 132.445 344.983 131.798L344.466 126.495H334.652C333.834 126.495 332.973 127.228 333.145 128.004L333.877 131.496C334.049 132.272 334.609 133.005 335.384 133.005L344.682 133.695Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M338.655 126.538L309.599 126.279",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M137.113 99.3778L69.1855 98.7743V102.223L137.113 102.827V99.3778Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M137.801 21.3052L137.026 141.972",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48047 20.6583L181.752 21.8654C189.629 21.9085 221.699 21.8223 240.037 24.2364C246.666 25.0987 249.765 26.6938 254.457 31.2635",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86719 13.761L197.764 14.9681C205.599 15.0112 223.162 14.149 230.264 17.3392C236.334 20.012 241.801 21.0467 246.493 25.6164",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M248.904 27.082L256.825 26.5215",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M198.454 2.16449V22.0816",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3174 1V13.8901",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0029 1V13.847",
    stroke: "#939EAF",
    strokeWidth: 0.496248,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleRightSide);
export default __webpack_public_path__ + "static/media/vehicle-right-side.70dca31d1f4e939964438979f9f294c5.svg";
export { ForwardRef as ReactComponent };